import type { MessageDto } from '../../api/types';
import { cn } from '../../lib/cn';

const ROLE_STYLES: Record<MessageDto['author'], string> = {
  client: 'self-start bg-muted text-fg',
  agent: 'self-end bg-blue-100 text-blue-900',
  human: 'self-end bg-emerald-100 text-emerald-900',
  system: 'self-center bg-transparent text-muted-fg italic text-xs',
};

const ROLE_LABELS: Record<MessageDto['author'], string> = {
  client: 'Клиент',
  agent: 'Агент',
  human: 'Менеджер',
  system: 'Система',
};

export function MessageBubble({ message }: { message: MessageDto }) {
  const time = message.sentAt ?? message.createdAt;
  if (message.author === 'system') {
    return <div className={cn('max-w-[80%] px-2 py-1', ROLE_STYLES.system)}>{message.text}</div>;
  }
  return (
    <div className={cn('flex max-w-[70%] flex-col gap-1 rounded-lg px-3 py-2 text-sm', ROLE_STYLES[message.author])}>
      <div className="flex items-center justify-between gap-3 text-xs opacity-70">
        <span>{ROLE_LABELS[message.author]}</span>
        <span>{new Date(time).toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' })}</span>
      </div>
      <p className="whitespace-pre-wrap break-words">{message.text}</p>
      {message.status === 'failed' && <span className="text-xs text-red-600">Не удалось отправить</span>}
      {message.status === 'cancelled' && <span className="text-xs text-amber-600">Отменено</span>}
    </div>
  );
}
